<template>
  <div class="content">
    <div class="content-select d-flex">
      <van-dropdown-menu>
        <van-dropdown-item
          v-model="value1"
          :options="option1"
          @change="selectChange"
        />
      </van-dropdown-menu>
      <!-- <van-field
        v-model="memberId"
        placeholder="Member ID"
        class="custom-field"
        :style="{ borderColor: focus ? '#076237' : '#666666' }"
        @focus="focus = true"
        @blur="focus = false"
      >
      </van-field> -->
    </div>
    <!-- 列表展示 -->
    <van-list
      v-model="loading"
      :finished="finished"
      loading-text=" "
      @load="loadMore"
      class="order-list"
    >
      <div class="content-card">
        <div
          class="content-card--i"
          v-for="(item, index) in userList"
          :key="index"
        >
          <div class="d-flex f-t-15 m-b-10 m-t-15">
            <p>
              {{ item.userId }}
            </p>
            <img
              @click="copyText(item.userId)"
              class="m-l-10"
              width="16px"
              height="17px"
              src="../../assets/img/drawer/drawer_copy.png"
            />
          </div>

          <div class="f-t-13">
            <p class="d-flex-s m-t-15">
              <span class="font-color">{{ $lang.share_txt38 }}</span>
              {{ getTime(item.loginDate) }}
            </p>
            <p class="w-line"></p>
            <p class="d-flex-s">
              <span class="font-color">{{ $lang.share_txt36 }}</span>
              {{ item.hisSubordinatesCount }}
            </p>
            <p class="w-line"></p>
            <p class="d-flex-s">
              <span class="font-color">{{ $lang.share_txt34 }}</span>
              {{ getCurrency }}
              {{ item.depositAmount }}
            </p>
            <p class="w-line"></p>
            <p class="d-flex-s">
              <span class="font-color">{{ $lang.share_txt37 }}</span>
              {{ getCurrency }} {{ item.validBets }}
            </p>
            <p class="w-line"></p>
            <p class="d-flex-s">
              <span class="font-color">{{ $lang.share_txt35 }}</span>
              <span class="error-color">{{ item.accountStatus }}</span>
            </p>
          </div>

          <div v-if="userList.length > 0" class="content-card--ig t-c">
            <p class="content-card--igt"></p>
            {{ $lang.VIP }} {{ item.vipLevel }}
          </div>
        </div>
      </div>
      <!-- 没有数据时显示 -->
      <van-empty
        v-if="!userList.length && !loading"
        :image="require('../../assets/img/common/img_no_data.png')"
        :description="$lang.noempt"
      />
    </van-list>
  </div>
</template>
<script>
import { GetSubUserList } from '@/api/common'
import { contentOf, failMessage, isOkResponse } from '@/components/loginFlow'
import {
  copyTextToClipboard,
  hasShareUnavailableMarker,
  shareFailMessage
} from './shareSafety'
export default {
  name: 'ShareThree',
  components: {},
  data() {
    return {
      userList: [],
      loading: false, // 是否正在加载更多数据
      finished: false, // 是否已经加载完所有数据
      page: 0, // 当前页码
      pageSize: 15,
      memberId: '',
      focus: false,
      value1: 6,
      option1: [
        { text: this.$lang.billGame_txt4, value: 0 },
        { text: this.$lang.billGame_txt5, value: 1 },
        { text: this.$lang.billGame_txt6, value: 2 },
        { text: this.$lang.billGame_txt7, value: 3 },
        { text: this.$lang.billGame_txt8, value: 4 },
        { text: this.$lang.billGame_txt9, value: 5 },
        { text: this.$lang.billGame_txt10, value: 6 }
      ],
      params: {}
    }
  },
  mounted() {},
  methods: {
    showToast(options) {
      if (typeof this.$toast === 'function') this.$toast(options)
    },
    requireLogin() {
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    canReadTeamUsers() {
      if (this.token) return true
      this.finished = true
      this.loading = false
      this.requireLogin()
      return false
    },
    showReadFailure(data) {
      this.showToast({
        message: shareFailMessage(data, failMessage(data, this.$lang.common_txt114 || 'Request failed')),
        icon: 'cross'
      })
    },
    teamUserReadSnapshot() {
      return {
        userList: this.userList.slice(),
        page: this.page,
        finished: this.finished,
        params: { ...(this.params || {}) }
      }
    },
    hasTeamUserReadState(snapshot) {
      const params = snapshot && snapshot.params ? snapshot.params : {}
      return Boolean(snapshot) && (snapshot.page > 0 || snapshot.finished || snapshot.userList.length > 0 || Object.keys(params).length > 0)
    },
    restoreTeamUserReadSnapshot(snapshot) {
      if (!this.hasTeamUserReadState(snapshot)) return false
      this.userList = snapshot.userList.slice()
      this.page = snapshot.page
      this.finished = snapshot.finished
      this.params = { ...(snapshot.params || {}) }
      return true
    },
    failTeamUserRead(data, snapshot) {
      if (!this.restoreTeamUserReadSnapshot(snapshot)) {
        this.finished = true
      }
      this.showReadFailure(data)
      return false
    },
    safeDisplayText(value, fallback = '') {
      if (value === undefined || value === null) return fallback
      return String(value)
    },
    safeDisplayNumber(value, fallback = 0) {
      if (value === undefined || value === null || value === '') return fallback
      const number = Number(value)
      return Number.isFinite(number) ? number : fallback
    },
    normalizeTeamUserRow(row = {}) {
      return {
        ...row,
        userId: this.safeDisplayText(row.userId),
        loginDate: this.safeDisplayText(row.loginDate),
        hisSubordinatesCount: this.safeDisplayNumber(row.hisSubordinatesCount),
        depositAmount: this.safeDisplayNumber(row.depositAmount),
        validBets: this.safeDisplayNumber(row.validBets),
        accountStatus: this.safeDisplayText(row.accountStatus),
        vipLevel: this.safeDisplayNumber(row.vipLevel)
      }
    },
    getTime(v) {
      if (!v) return ''
      let time = this.$dayjs(v).format('YYYY-MM-DD')
      return time.slice(8, 10) + '/' + time.slice(5, 7) + '/' + time.slice(0, 4)
    },
    readDateRange(range) {
      if (typeof range === 'string' && range.includes('&')) {
        const parts = range.split('&')
        return [parts[0] || '', parts[1] || '']
      }
      if (Array.isArray(range)) {
        return [range[0] || '', range[1] || '']
      }
      if (typeof range === 'string') {
        return [range.slice(0, 19), range.slice(20, 40)]
      }
      return ['', '']
    },
    selectChange(i) {
      if (!this.canReadTeamUsers()) return
      if (i === 0) {
        const [startDate, endDate] = this.readDateRange(this.$getTodayRange())
        this.GetSubUserList(startDate, endDate, 'reset')
      } else if (i === 1) {
        const [startDate, endDate] = this.readDateRange(this.$getYesterdayRange())
        this.GetSubUserList(startDate, endDate, 'reset')
      } else if (i === 2) {
        const [startDate, endDate] = this.readDateRange(this.$getThisWeekRange())
        this.GetSubUserList(startDate, endDate, 'reset')
      } else if (i === 3) {
        const [startDate, endDate] = this.readDateRange(this.$getLastWeekRange())
        this.GetSubUserList(startDate, endDate, 'reset')
      } else if (i === 4) {
        const [startDate, endDate] = this.readDateRange(this.$getThisMonthRange())
        this.GetSubUserList(startDate, endDate, 'reset')
      } else if (i === 5) {
        const [startDate, endDate] = this.readDateRange(this.$getLastMonthRange())
        this.GetSubUserList(startDate, endDate, 'reset')
      } else if (i === 6) {
        this.GetSubUserList('', '', 'resetAll')
      }
    },
    resetList() {
      this.userList = [] // 清空列表
      this.page = 0 // 重置页码为0
      this.finished = false // 重置加载完成状态
    },
    async GetSubUserList(startDate, endDate, type) {
      if (!this.canReadTeamUsers()) return
      const previousReadState = this.teamUserReadSnapshot()
      const shouldReset = type === 'reset' || type === 'resetAll'
      if (shouldReset) {
        this.page = 0
        this.finished = false
      }
      if (startDate && endDate) {
        this.params = {
          startDate: startDate,
          endDate: endDate,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      } else if (type === 'All' || type === 'resetAll') {
        this.params = {
          startDate: '',
          endDate: '',
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      } else if (type === 'load') {
        this.params = {
          startDate: startDate,
          endDate: endDate,
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      }
      this.loading = true
      try {
        const data = await GetSubUserList(this.params)
        if (hasShareUnavailableMarker(data)) {
          return this.failTeamUserRead(data, previousReadState)
        } else if (isOkResponse(data)) {
          const content = contentOf(data)
          let list = content.userList || content.list || content.records || []
          if (!Array.isArray(list)) list = []
          if (shouldReset) {
            this.userList = []
          }
          // 如果没有新数据，表示加载完成
          if (list.length < this.pageSize) {
            this.finished = true
          }
          this.mergeUserList(list)
          // 加载下一页
          this.page++
        } else {
          return this.failTeamUserRead(data, previousReadState)
        }
      } catch (e) {
        return this.failTeamUserRead(e, previousReadState)
      } finally {
        this.loading = false
      }
    },
    mergeUserList(list) {
      const seen = new Set(this.userList.map(item => item && item.userId))
      const next = list.filter(item => {
        const key = item && item.userId
        if (!key) return true
        if (seen.has(key)) return false
        seen.add(key)
        return true
      }).map(item => this.normalizeTeamUserRow(item || {}))
      this.userList = this.userList.concat(next)
    },
    // 加载更多数据
    loadMore() {
      if (!this.params) this.params = {}
      const startDate = this.params.startDate || ''
      const endDate = this.params.endDate || ''
      this.GetSubUserList(startDate, endDate, 'load')
    },
    copyText(i) {
      const copyValue = String(i == null ? '' : i).trim()
      if (!copyValue) {
        this.showToast({
          message: this.$lang.noempt || this.$lang.common_txt114 || 'No data available',
          icon: 'cross'
        })
        return
      }
      try {
        const copied = copyTextToClipboard(copyValue)
        this.showToast({
          message: copied === true ? this.$lang.Sucesso : (this.$lang.copy_failed || 'Copy failed'),
          icon: copied === true ? 'success' : 'cross'
        })
      } catch (e) {
        this.showToast({
          message: this.$lang.copy_failed || 'Copy failed',
          icon: 'cross'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content-select {
  padding: 10px 5%;
  ::v-deep .van-overlay {
    background: transparent !important;
  }
}

/* 使用深度选择器覆盖样式 */
/* 修改下拉框标题区域样式（原本是蓝底白字） */
::v-deep .van-dropdown-menu__bar {
  // background-image: linear-gradient(117deg, #ffaf00 0%, #7041f3 85%);
  background: #3979e3;
  height: 30px !important;
  border-radius: 20px;
  border: none; /* 加黑色边框 */
  padding: 0 18px;

  .van-dropdown-menu__title {
    color: #ffffff !important; /* 黑色字体 */
  }
  .van-dropdown-menu__title--active {
    color: #ffffff !important;
  }
}

/* 修改下拉选项框样式 */
::v-deep .van-dropdown-item {
  width: 160px;
  border-radius: 15px;
  margin-top: 5px;
  margin-left: 5%;
  // border: 1px solid #cecece; /* 黑框 */
  height: 240px;

  .van-dropdown-item__content {
    max-height: 100%;
    background-color: @cont-bg; /* 白底 */
  }

  .van-cell {
    background-color: @cont-bg; /* 白底 */
    color: #ffffff; /* 黑字 */
    padding: 5px 16px;
  }
}

/* 当前选中项高亮样式 */
::v-deep .van-dropdown-item__option--active {
  color: @info-color !important;
  font-weight: bold;
}
::v-deep .van-dropdown-item__option--active {
  color: @info-color !important;
}
::v-deep .van-dropdown-item__option--active .van-dropdown-item__icon {
  color: @info-color !important;
}
.content-card {
  padding: 3% 3% 15%;
}
.content-card--i {
  position: relative;
  border-radius: 12px;
  justify-content: space-between;
  padding: 15px 18px;
  background-image: linear-gradient(180deg, #ffffff 0%, #e9f9f9 100%);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  margin-bottom: 15px;
}
.content-card--ig {
  position: absolute;
  // background-image: url('../../assets/img/share/item_vip.png'); /* 指定背景图片的路径 */
  // background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  // background-repeat: no-repeat; /* 防止图片重复 */
  width: 80px;
  top: -6px;
  left: 0;
  right: 0;
  padding-bottom: 3px;
  color: @info-color;
  // background-image: linear-gradient(117deg, #ffaf00 0%, #7041f3 85%);
  background: #1d567d;
  font-weight: bold;
  font-size: var(--vk-fs-15);
  border-radius: 15px 15px 15px 0;
}
.content-card--igt {
  margin-top: 3px;
  // text-shadow: 4px 4px 8px rgba(0, 0, 0, 0.9); /* 添加黑色阴影 */
}
::v-deep .van-loading {
  background: transparent;
}
.w-line {
  width: 92%;
  height: 2px;
  background: linear-gradient(
    to right,
    rgba(97, 97, 97, 0.1),
    #e5daed,
    rgba(97, 97, 97, 0.1)
  );
  margin: 10px auto;
}
.order-list {
  height: 72vh; /* 固定高度 */
  overflow-y: auto; /* 垂直方向可滚动 */
}
/* PC 端样式 */
@media (min-width: 769px) {
  ::v-deep .van-dropdown-item {
    left: 50% !important;
    transform: translate(-50%, -0%) !important;
    margin-left: -126px !important;
  }
}
</style>
